"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDomain = exports.invalidParam = void 0;
/**
 * Logs a message to the console and rejects.
 *
 * @param logMessage Message to be logged to console. Should contain function name.
 * @param errorMessage Message to be returned to frontend.
 * @param description Description of why the invalidation happened.
 * @returns Rejected Promise with error and description.
 */
function invalidParam(logMessage, errorMessage, description) {
    var error = new Error(errorMessage);
    console.log(logMessage);
    return Promise.reject({
        error: error,
        description: description,
    });
}
exports.invalidParam = invalidParam;
/**
 * Constructs a domain based on a given path.
 *
 * @param path String indicating a URL path
 * @returns String representing a constructed domain.
 */
function buildDomain(path) {
    var _a;
    var BASE_URL;
    if (typeof window === "undefined") {
        if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.SITE_ROOT) !== undefined) {
            BASE_URL = process.env.SITE_ROOT;
        }
        else {
            BASE_URL =
                process.env.NODE_ENV !== "production"
                    ? "https://www.wattpad.dev-prod"
                    : "https://www.wattpad.com";
        }
    }
    else {
        BASE_URL = "https://".concat(window.location.host);
    }
    return BASE_URL + path;
}
exports.buildDomain = buildDomain;
